<template>
  <vmodules
    v-if="modifiedModules && modifiedModules.length"
    type="global"
    :modules="modifiedModules"
    @toggle="handleSwitch"
  />
</template>

<script>
import vmodules from '@/components_new/vmodules/vmodules.vue';

export default {
  name: 'modules',

  components: {
    vmodules
  },

  data() {
    return {
      dependenciesModules: {
        'test': ['anticheating'],
        'videointerview': ['speech-to-text', 'emotions']
      }
    }
  },

  computed: {
    modules() {
      return this.$store.getters['adminCompanyModules/getModules'];
    },

    modifiedModules() {
      if (!this.modules || !this.modules.length) {
        return [];
      }

      let modulesList = [...this.modules];
      modulesList = this.checkDisabledModulesDependencies(modulesList);

      return modulesList;
    },

    companyId() {
      return this.$route.params.company_id
    },

    parentModules() {
      return Object.keys(this.dependenciesModules);
    }
  },

  methods: {
    checkDisabledModulesDependencies(modulesList) {
      let modules = [...modulesList];

      this.parentModules.forEach(parentModule => {
        const childModules = this.dependenciesModules[parentModule];

        childModules.forEach(childModule => {
          let isModuleEnabled = false;

          modules.forEach(item => {
            if (item.id === parentModule) {
              isModuleEnabled = item.is_enabled;
            }
          });

          modules = modules.map(item => {
            if (item.id !== childModule) {
              return item;
            }
            const isChildModuleEnabled = modules.find(item => item.id === childModule).is_enabled;

            return Object.assign(item, {
              is_disabled: !isModuleEnabled && !isChildModuleEnabled
            });
          })
        })
      });

      return modules;
    },
    fetchModules() {
      this.$store.dispatch('adminCompanyModules/fetch', { companyId: this.companyId });
    },

    handleSwitch(params) {
      this.$store.dispatch('adminCompanyModules/updateModule', {
        value: params.value,
        id: params.id,
        key: 'is_enabled',
        body: {
          company: {
            id: this.companyId
          },
          is_enabled: params.value,
          id: params.id
        }
      })
        .then(() => {
          this.$noty.success(this.$tr('vacancy.basic.form.modules.informers.save_success'));

          if (this.parentModules.find(item => item === params.id) && !params.value) {
            const childModules = this.dependenciesModules[params.id];

            childModules.forEach(childModule => {
              this.$store.dispatch('adminCompanyModules/updateModule', {
                value: false,
                id: childModule,
                key: 'is_enabled',
                body: {
                  company: {
                    id: this.companyId
                  },
                  is_enabled: false,
                  id: childModule
                }
              });
            })
          }
        })
        .catch(() => this.$noty.error(this.$tr('vacancy.basic.form.modules.informers.save_error')))
    }
  },

  beforeMount () {
    this.fetchModules()
  }
};
</script>

<style lang="scss" scoped>
</style>
